import {Component, HostListener, inject, Signal, QueryList, ViewChildren, AfterViewInit, OnInit } from '@angular/core';
import {Router, ActivatedRoute, NavigationEnd} from '@angular/router';
import {CommonModule, NgIf} from '@angular/common';
import {map, filter} from 'rxjs/operators';
import {toSignal} from '@angular/core/rxjs-interop';
import {MediaQueryService} from '../../services/media-query/media-query.service';
import {LbSidebarComponent} from '../shared/lb-sidebar/lb-sidebar.component';
import {LbHeaderComponent} from '../shared/lb-header/lb-header.component';
import {LbFooterComponent} from '../shared/lb-footer/lb-footer.component';
import {LbFullWidthSeparatorComponent} from "../shared/lb-full-width-separator/lb-full-width-separator.component";
import {LbFullWidthDropdownComponent} from "../shared/lb-full-width-dropdown/lb-full-width-dropdown.component";
import {LbBannerComponent} from "../shared/lb-banner/lb-banner.component";
import {LbButtonGridComponent} from "../shared/lb-button-grid/lb-button-grid.component";
import {LbDashboardOverviewComponent} from "../shared/lb-dashboard-overview/lb-dashboard-overview.component";
import {LbChartEchelonComponent} from "../toolbox/lb-chart-echelon/lb-chart-echelon.component";
import { SidebarComponent } from 'src/app/shared/toolbox/sidebar/sidebar.component';
import { HeaderComponent } from 'src/app/shared/toolbox/header/header.component';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Component({
  standalone: true,
  selector: 'app-lb-dashboard',
  templateUrl: './lb-dashboard.component.html',
  styleUrls: ['./lb-dashboard.component.scss'],
  imports: [
    CommonModule,
    NgIf,
    LbSidebarComponent,
    LbHeaderComponent,
    LbFooterComponent,
    LbFullWidthSeparatorComponent,
    LbFullWidthDropdownComponent,
    LbButtonGridComponent,
    LbBannerComponent,
    LbDashboardOverviewComponent,
    LbChartEchelonComponent,
    SidebarComponent,
    HeaderComponent
  ],
})
export class LbDashboardComponent  implements AfterViewInit{
  title = 'leadership dashboard';
  showTheme: boolean = true;
  backgroundImage = 'https://accounts-app.s3.eu-west-1.amazonaws.com/Leadership-Barometer_Button_Image.svg'
  sponsorLogos= []

  initialButton: any =
    {
      name: 'The respondents',
      clickFunction: this.onButtonClick.bind(this, 'The respondents')
    }
  buttonList: any = [
    {
      name: 'The market',
      clickFunction: this.onButtonClick.bind(this, 'The market')
    },
    {
      name: 'My company',
      clickFunction: this.onButtonClick.bind(this, 'My company')
    },
    {
      name: 'My team',
      clickFunction: this.onButtonClick.bind(this, 'My team')
    },
    // {
    //   name: 'Boards',
    //   clickFunction: this.onButtonClick.bind(this, 'Boards')
    // },
    {
      name: 'Priorities',
      clickFunction: this.onButtonClick.bind(this, 'Priorities')
    },
    {
      name: 'Purpose and values',
      clickFunction: this.onButtonClick.bind(this, 'Purpose and values')
    },
    {
      name: 'Strategy',
      clickFunction: this.onButtonClick.bind(this, 'Strategy')
    },
    {
      name: 'Skills',
      clickFunction: this.onButtonClick.bind(this, 'Skills')
    }
  ];

  dropdownStates: { [key: string]: boolean } = {};

  private mediaQueryService: MediaQueryService = inject(MediaQueryService);
  public isMobile: Signal<boolean> = toSignal(
    this.mediaQueryService
      .getDisplayType()
      .pipe(map(({isMobile}) => isMobile)),
    {initialValue: window.innerWidth < 768}
  );

  @HostListener('window:resize', ['$event']) onResize(event: Event): void {
    const width = (event.target as Window).innerWidth;
    this.mediaQueryService.setDisplaySize(width);
  }
  @ViewChildren(LbFullWidthDropdownComponent) dropdownElements!: QueryList<LbFullWidthDropdownComponent>;

  constructor(private router: Router, private route: ActivatedRoute, private http:HttpClient) {
    // Subscribe to router events to check for route changes
    this.router.events
      .pipe(
        filter(
          (event): event is NavigationEnd => event instanceof NavigationEnd
        )
      )
      .subscribe((event: NavigationEnd) => {
        // Check if the current route is "/"
        if (
          /^\/rxlogin.*/.test(event.url) || event.url.includes('/leadership-barometer') && window.self !== window.top
        ) {
          this.showTheme = false; // Set showTheme to false if current route is "/"
        } else {
          this.showTheme = true; // Otherwise, set it to true
        }
      });

    this.buttonList.forEach((button:any) => {
      this.dropdownStates[button.name] = false;
    });

  }

  surveyCode:any = null;

  ngOnInit() {
    this.route.paramMap.subscribe(params => {

      this.surveyCode = params.get('survey_code')

      if (this.surveyCode === null) {
        let newest_survey_url = `${environment.backend_base}lb/get_latest_lb_survey/`
        this.http.post(newest_survey_url, {}).subscribe((response:any) => {
          if (response.message === 'success') {
            const targetUrl = `/leadership-barometer/${response.survey_code}`
            const forwardURL = environment.frontend_base+targetUrl
            window.location.href = forwardURL;

          }
          else {
            const forwardURL = environment.frontend_base
            window.location.href = forwardURL;
          }
        })
      }
      else {
        let url = `${environment.backend_base}lb/get_survey_echelons/`
        let data = {
          survey_code: this.surveyCode
        }

        this.http.post(url, data).subscribe((response:any) => {
          let prepData = response.map((item:any) => ({
            ...item,
            clickFunction: this.onButtonClick.bind(this, item.name)
          }));
          this.initialButton = prepData[0]
          this.buttonList = prepData.slice(1).map((item:any) => ({
            ...item,
            clickFunction: this.onButtonClick.bind(this, item.name)
          }));
        })
      }


    })
  }

  ngAfterViewInit(): void {
    // Ensure dropdownElements are available after view initialization
    if (this.dropdownElements.length === 0) {
      console.error('No dropdown elements found. Check the template for #dropdown references.');
    }
  }

  toggleDropdown(name: string): void {
    this.dropdownStates[name] = !this.dropdownStates[name];
  }

  onButtonClick(name: string): void {
    // Close all dropdowns
    Object.keys(this.dropdownStates).forEach((key) => {
      this.dropdownStates[key] = false;
    });

    // Open the clicked dropdown
    this.dropdownStates[name] = true;

    // Handle scrolling logic
    if (name === 'The respondents') {
      // Scroll to the specific dropdown directly
      const dropdownElement = document.querySelector('[title="The respondents"]');
      if (dropdownElement) {
        const elementPosition = dropdownElement.getBoundingClientRect().top + window.scrollY;

        // Adjust for headers or other offsets
        const headerHeight = document.querySelector('header')?.offsetHeight || 0;
        const scrollOffset = 20; // Optional extra space
        const scrollPosition = elementPosition - headerHeight - scrollOffset;

        window.scrollTo({ top: scrollPosition, behavior: 'smooth' });
      } else {
        console.error(`Dropdown element with title "The respondents" not found.`);
      }
    } else {
      // Scroll to other dropdowns
      const allButtons = [this.initialButton, ...this.buttonList];
      const index = allButtons.findIndex((button) => button.name === name);

      const dropdownArray = this.dropdownElements.toArray();
      const dropdownElement = dropdownArray[index]?.elementRef.nativeElement;

      if (dropdownElement) {
        const elementPosition =
          dropdownElement.getBoundingClientRect().top + window.scrollY;
        const headerHeight = document.querySelector('header')?.offsetHeight || 0;
        const scrollOffset = 20;

        window.scrollTo({ top: elementPosition - headerHeight - scrollOffset, behavior: 'smooth' });
      } else {
        console.error(`Dropdown element for "${name}" not found. Index: ${index}`);
      }
    }
  }

  downloadPPT(url:string) {
  window.open(url, '_blank');
  }

  surveyRedirect() {
    this.router.navigate(['/leadership-barometer/take-the-survey']);
  }

}
